import { Link, useNavigate } from '@tanstack/react-router';
import { FileArrowUpIcon } from '@phosphor-icons/react';
import { T } from 'gt-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useFeatureFlag } from '@/integrations/feature-flags/feature-flags';
import paths from '@/paths';

export function ToolsMenu({
  hideFeatureSignups = false,
}: {
  /**
   * When true (kill switch on), restore the pre-teaser behavior: hide Tools
   * entirely unless a real tool (file extraction) is enabled. When false, a
   * missing tool still shows Tools linking to the pitch page.
   */
  hideFeatureSignups?: boolean;
}) {
  const navigate = useNavigate();
  const { enabled: fileExtractionEnabled } = useFeatureFlag(
    'tools-page-file-extraction-enabled',
    false,
  );

  if (!fileExtractionEnabled) {
    if (hideFeatureSignups) {
      return null;
    }
    return (
      <Button variant="ghost" size="sm" asChild>
        <Link to={paths.authenticated.featurePreviews.tools}>
          <T context="top navbar tools link label">Tools</T>
        </Link>
      </Button>
    );
  }

  return (
    <DropdownMenu
      onOpenChange={(open) => {
        if (!open) {
          (document.activeElement as HTMLElement | null)?.blur();
        }
      }}
    >
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="focus-visible:ring-0 data-[state=open]:bg-transparent"
        >
          <T context="top navbar tools dropdown label">Tools</T>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={() =>
            navigate({ to: paths.authenticated.tools.fileExtraction })
          }
        >
          <FileArrowUpIcon />
          <T context="tools menu item for file extraction page">
            File Extraction
          </T>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
